export const OPEN_CONTEXT_MENU = 'OPEN_CONTEXT_MENU';
export const CLOSE_CONTEXT_MENU = 'CLOSE_CONTEXT_MENU';

export interface ToggleContextMenuAction {
  type: typeof OPEN_CONTEXT_MENU | typeof CLOSE_CONTEXT_MENU;
  payload?: string;
}

export type toggleContextMenuActionTypes = ToggleContextMenuAction;
